import React, { useState, useEffect, useImperativeHandle, forwardRef, } from "react";
import { Box, Typography, TextField } from "@mui/material";
import './ChannelDetail.css';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { toast } from 'react-toastify';

import IconButton from '@mui/material/IconButton';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveIcon from '@mui/icons-material/Remove';
import SaveIcon from '@mui/icons-material/Save'
import EditIcon from '@mui/icons-material/Edit'
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import {
  useDispatch, useSelector
} from "react-redux";
import { getChannelWebHooks, updateWebHook,saveWebHook,delWebHook } from "../../../../../Store/Features/WebHooks/SingleChannelHooks";
import CircularProgress from '@mui/material/CircularProgress';
import { confirmAlert } from 'react-confirm-alert';  
import 'react-confirm-alert/src/react-confirm-alert.css';  
import { grey } from "@mui/material/colors";
import { current } from "@reduxjs/toolkit";
import {genApikey} from "../../../../../Store/Features/Users/UserSlice"


export const GenerateApi_KeyForm = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [fieldReadOnly , setFieldValue]= useState()
  const [count, setCount] = useState([{
    user_id: '',
    event_name:'',
    event_id:0,
    webhook_url: "",
    
  }]);
  const webhooks = useSelector(state => state.singleChannelWebhooks.value);
  const Loading = useSelector(state => state.singleChannelWebhooks.loading);
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  useEffect(() => {
    if (isObjEmpty(webhooks))
      dispatch(getChannelWebHooks(slug));

  }, []);

  useEffect(() => {
    
    setCount(webhooks);

  }, [webhooks]);

  const addWebHook = () => {
    let temp = [...count];
    temp.push({
      channel_id: slug,
      event_name:'select webhook event name',
      event_id: 0,
      webhook_url: "",
     
    });
    setCount(temp);

  };
  const removeWebhook = (index,id) => {
    const options = {
      
      title:'Confirmation',
      message: 'Are you sure to delete Webhook?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const temp = [...count];
            temp.splice(index, 1);
            setCount(temp);
            const Id = id;
            if(Id){
              dispatch(delWebHook(Id)).then(()=>{
                dispatch(getChannelWebHooks(slug))
              });
               }
              }
        },
        {
          label: 'No',
          onClick: () => {
              console.log('here is iside no');
          }
        }
      ],
    }
    console.log('here is options object', options)
    confirmAlert(options);
   
   
  };

  useImperativeHandle(ref, () => ({
    save() {
      save();
    },

  }));

  const save = () => {
    // const data = {
    //   "channel_id": slug,
    //   "delete_event_ids": [4],
    //   webhooks: count
    // };
    // dispatch(updateWebHook(data));
  }

  const editField = (item) =>{
    setFieldValue(item);
    console.log('here is field values check',current)
  }

  const createWebhook = (item) => {
    console.log('here is data inside webhook.......',item)
    if(item.webhook_url){
      const data = item
      dispatch(saveWebHook(data)).then(()=>{
        dispatch(getChannelWebHooks(slug))
      });
    }else{
      toast.error('Add Hook info');
    }
   
    

  };

  const updatingWebHook = (item) => {
    console.log('here is data inside webhook',item)
    const data = item
    dispatch(updateWebHook(data)).then(()=>{
      dispatch(getChannelWebHooks(slug))
    });
  };
 

  // old method

  const editWebHookUrl = (index, e) => {
    let temp = [...count];
    let old = temp[index];
    const change = { ...old, webhook_url: e.target.value };
    temp[index] = change;
    setCount(temp);
  };

  // const editWebHookUrl = (index, item) => {
  //   let temp = [...count];
  //   let old = temp[index];
  //   const change = { ...old, item};
  //   temp[index] = change;
  //   setCount(temp);
  // };

  const editWebHookEvent = (index, e) => {
    
    let temp = [...count];
    let old = temp[index];
    let change = { ...old, event_id: e.target.value };
    change = {...change,event_name:getEventName(e.target.value)}
    temp[index] = change;
    console.log("e",temp[index])
    setCount(temp);
  };

  return (
    <>
      {Loading ? (<CircularProgress />) : (<>
        <Box sx={{ display: "flex" }}>
          <IconButton color="primary" aria-label="upload picture" component="label" onClick={addWebHook} >
            <AddCircleOutlineIcon sx={{ color: "#EC492F" }} />
          </IconButton>
        </Box>
        {count?.map((item, index) => {
          
          return (
            <Box className="Box3">
              <Select1 value={item.event_id} eventHandler={editWebHookEvent} index={index} itemId={item.id} readOnly={fieldReadOnly} />
              <TextField className={item.id == fieldReadOnly ? 'TextField3':'inputbg'} id="outlined-basic" label="Add url" variant="outlined" value={item.webhook_url} InputProps={{
               readOnly: item.id == fieldReadOnly || item.webhook_url == "" ? false :true,
               }} onChange={e => editWebHookUrl(index, e)} InputLabelProps={{ shrink: item ? true : false }}   />
              <IconButton color="primary" aria-label="upload picture" component="label" onClick={() => removeWebhook(index,item.id)} >
                <RemoveIcon sx={{ color: "#EC492F" }}  />
              </IconButton>
              { item.id  ?(
                 <IconButton color="primary" aria-label="upload picture" component="label"  >
                  {  item.id !== fieldReadOnly ? (
                    <EditIcon className="icon-btn" onClick={()=>editField(item.id)}  />
                  ):(
                    <SaveIcon className="icon-btn" onClick={() => updatingWebHook(item)} />
                  )

                  }
                 
                 
                 </IconButton>
                ):
                (
                <IconButton color="primary" aria-label="upload picture" component="label" onClick={() => createWebhook(item)} >
                <SaveIcon className="icon-btn" />
               </IconButton>
              )
              }
            </Box>);
        })}</>)}


    </>
  );
});

function Select1({ value, eventHandler, index,itemId,readOnly }) {
  
  return (
    <FormControl sx={{ width: "30%" }}>
      <InputLabel sx={{
        "font-family": "Circe",
        "font-size": "14px",
        "font-weight": 400,
        top: "3px"
      }}>Add Event</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="Add Event"
        key="Add Event"
        onChange={e => eventHandler(index, e)}
        className={itemId == readOnly ? '':'selectbg'} readOnly={itemId == readOnly ? false :true}
      >
        <MenuItem  value={0} selected>Select user to generate api key</MenuItem>
        <MenuItem  value={1}>user1</MenuItem>
        <MenuItem  value={3}>user2</MenuItem>

      </Select>
    </FormControl> 

  );
}

const getEventName = (event) =>{
  switch(event) {
    case 1:
      return "product.add"
    case 2:
      return "order.add"
    default:
      return "product.add"
  }
}